import _moment from "../../libs/moment"
const dateRange = (props) => {
  const customRange = props?.range?? {}
  const customFrom = props?.from?? {}
  const customTo = props?.to?? {}

  const rangeName = customRange.name?? "range"
  const fromName = customFrom.name?? "from"
  const toName = customTo.name?? "to"

  const defaultOptionsFormFilter = [
    {value: 0, label: "main.lastWeek"},
    {value: 1, label: "main.lastMonth"},
    {value: 2, label: "main.custom"}
  ]

  const defaultOptionsFormCreateUpdate = [
    {value: 0, label: "main.onlyForToday"},
    {value: 1, label: "main.oneWeekfromToday"},
    {value: 2, label: "main.oneMonthFromToday"},
    {value: 3, label: "main.anotherDateRange"}
  ]

  const defaultOnChangeFormFilter = (ctx) => {
    if (ctx.state[rangeName] === 0) ctx.setState({
      [fromName]: _moment().add(-7, 'days').format('YYYY-MM-DD'),
      [toName]: _moment().format('YYYY-MM-DD')
    })
    else if (ctx.state[rangeName] === 1) ctx.setState({
      [fromName]: _moment().add(-30, 'days').format('YYYY-MM-DD'),
      [toName]: _moment().format('YYYY-MM-DD')
    })
    else ctx.setState({[fromName]: null, [toName]: null})
  }

  const defaultOnChangeFormCreateUpdate = (ctx) => {
    if (ctx.state[rangeName] === 0) ctx.setState({[fromName]: _moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), [toName]: _moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')})
    else if (ctx.state[rangeName] === 1) ctx.setState({[fromName]: _moment().format('YYYY-MM-DD'), [toName]: _moment().add(+7, 'days').format('YYYY-MM-DD')})
    else if (ctx.state[rangeName] === 2) ctx.setState({[fromName]: _moment().format('YYYY-MM-DD'), [toName]: _moment().add(+30, 'days').format('YYYY-MM-DD')})
    else if (ctx.state[rangeName] === 3) ctx.setState({[fromName]: null, [toName]: null})
  }

  const items = props?.isFormCrud ? defaultOptionsFormCreateUpdate : defaultOptionsFormFilter
  const onChange = props?.isFormCrud ? defaultOnChangeFormCreateUpdate : defaultOnChangeFormFilter

  let range = {
    name: rangeName,
    value: null,
    type: "select",
    label: "main.dateRange",
    placeholder: "main.dateRange",
    opts: {
      style: 'float-label',
      items: items
    },
    onChange: onChange
  }

  const rangeOpts = range.opts?? {}
  const customRangeOpts = customRange.opts?? {}
  range = {...range, ...customRange}
  range.opts = {...rangeOpts, ...customRangeOpts}

  let from = {
    name: fromName,
    value: null,
    type: "date",
    label: "main.from",
    opts: {
      style: 'float-label',
      selectsStart: true,
      startDate: (ctx) => ctx.state[fromName] ? _moment(ctx.state[fromName]) : null,
      endDate: (ctx) => ctx.state[toName] ? _moment(ctx.state[toName]) : null
    },
    renderIf: props?.isFormCrud 
      ? ctx => (ctx.state[fromName] || ctx.state[rangeName] === 3) && (range.renderIf ? range.renderIf(ctx) : true)
      : ctx => ctx.state[rangeName] === 2 && (range.renderIf ? range.renderIf(ctx) : true)
  }

  const fromOpts = from.opts?? {}
  const customFromOpts = customFrom.opts?? {}
  from = {...from, ...customFrom}
  from.opts = {...fromOpts, ...customFromOpts}

  let to = {
    name: toName,
    value: null,
    type: "date",
    label: "main.to",
    opts: {
      style: 'float-label',
      selectsEnd: true,
      startDate: (ctx) => _moment(ctx.state[fromName]),
      endDate: (ctx) => _moment(ctx.state[toName]),
      minDate: (ctx) => _moment(ctx.state[fromName])
    },
    renderIf: props?.isFormCrud 
    ? ctx => (ctx.state[toName] || (ctx.state[rangeName] === 3 && ctx.state[fromName])) && (range.renderIf ? range.renderIf(ctx) : true)
    : ctx => (ctx.state[rangeName] === 2 && ctx.state[fromName]) && (range.renderIf ? range.renderIf(ctx) : true)
  }

  const toOpts = to.opts?? {}
  const customToOpts = customTo.opts?? {}
  to = {...to, ...customTo}
  to.opts = {...toOpts, ...customToOpts}

  return  [range, from, to]
}
export default dateRange